module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "vuemenu navigation"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grid-block app-block zone collapse medium-3 large-2 vertical style-scope tpl-dashboard",
    attrs: {
      "id": "griBlockMenuLeft"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid-content leftbar-content-parent style-scope tpl-dashboard"
  }, [_c('div', {
    staticClass: "leftbar-content style-scope tpl-dashboard"
  }, [_c('app-menulist', {
    staticClass: "style-scope tpl-dashboard"
  }, [_c('div', {
    staticClass: "menu-container style-scope app-menulist",
    attrs: {
      "data-tippy-content": "Dados pessoais",
      "tabindex": "0"
    }
  }, [_c('a', {
    staticClass: "links style-scope app-menulist",
    attrs: {
      "href": "#/dashboard/user/profile"
    }
  }, [_c('div', {
    staticClass: "item style-scope app-menulist"
  }, [_c('i', {
    staticClass: "fa fa-user style-scope app-menulist"
  }), _vm._v(" "), _c('span', {
    staticClass: "labelItem style-scope app-menulist"
  }, [_vm._v("Dados pessoais")])])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-container style-scope app-menulist",
    attrs: {
      "data-tippy-content": "ComprarCurso",
      "tabindex": "0"
    }
  }, [_c('a', {
    staticClass: "links style-scope app-menulist",
    attrs: {
      "href": "#/dashboard/buy"
    }
  }, [_c('div', {
    staticClass: "item style-scope app-menulist"
  }, [_c('i', {
    staticClass: "fa fa-money-check-alt style-scope app-menulist"
  }), _vm._v(" "), _c('span', {
    staticClass: "labelItem style-scope app-menulist"
  }, [_vm._v("Comprar Curso")])])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-container style-scope app-menulist",
    attrs: {
      "data-tippy-content": "Contas",
      "tabindex": "0"
    }
  }, [_c('a', {
    staticClass: "links style-scope app-menulist",
    attrs: {
      "href": "#/dashboard/user/accounts"
    }
  }, [_c('div', {
    staticClass: "item style-scope app-menulist"
  }, [_c('i', {
    staticClass: "fa fa-money-check-alt style-scope app-menulist"
  }), _vm._v(" "), _c('span', {
    staticClass: "labelItem style-scope app-menulist"
  }, [_vm._v("Contas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-container style-scope app-menulist",
    attrs: {
      "data-tippy-content": "Comprar Fichas",
      "tabindex": "0"
    }
  }, [_c('a', {
    staticClass: "links style-scope app-menulist",
    attrs: {
      "href": "#/dashboard/buy"
    }
  }, [_c('div', {
    staticClass: "item style-scope app-menulist"
  }, [_c('i', {
    staticClass: "fa fa-cart-plus style-scope app-menulist"
  }), _vm._v(" "), _c('span', {
    staticClass: "labelItem style-scope app-menulist"
  }, [_vm._v("Comprar Fichas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-container style-scope app-menulist",
    attrs: {
      "data-tippy-content": "Vender Fichas",
      "tabindex": "0"
    }
  }, [_c('a', {
    staticClass: "links style-scope app-menulist",
    attrs: {
      "href": "#/dashboard/sell"
    }
  }, [_c('div', {
    staticClass: "item style-scope app-menulist"
  }, [_c('i', {
    staticClass: "fa fa-cart-arrow-down style-scope app-menulist"
  }), _vm._v(" "), _c('span', {
    staticClass: "labelItem style-scope app-menulist"
  }, [_vm._v("Vender Fichas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-container style-scope app-menulist",
    attrs: {
      "data-tippy-content": "Afiliados",
      "tabindex": "0"
    }
  }, [_c('a', {
    staticClass: "links style-scope app-menulist",
    attrs: {
      "href": "#/dashboard/afilliates"
    }
  }, [_c('div', {
    staticClass: "item style-scope app-menulist"
  }, [_c('i', {
    staticClass: "fa fa-users style-scope app-menulist"
  }), _vm._v(" "), _c('span', {
    staticClass: "labelItem style-scope app-menulist"
  }, [_vm._v("Afiliados")])])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-container style-scope app-menulist",
    attrs: {
      "data-tippy-content": "Histórico",
      "tabindex": "0"
    }
  }, [_c('a', {
    staticClass: "links style-scope app-menulist",
    attrs: {
      "href": "#/dashboard/history"
    }
  }, [_c('div', {
    staticClass: "item active style-scope app-menulist"
  }, [_c('i', {
    staticClass: "fa fa-chart-line style-scope app-menulist"
  }), _vm._v(" "), _c('span', {
    staticClass: "labelItem style-scope app-menulist"
  }, [_vm._v("Histórico")])])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-container style-scope app-menulist",
    attrs: {
      "data-tippy-content": "Serviços",
      "tabindex": "0"
    }
  }, [_c('a', {
    staticClass: "links style-scope app-menulist",
    attrs: {
      "href": "#/dashboard/admin/services/all"
    }
  }, [_c('div', {
    staticClass: "item style-scope app-menulist"
  }, [_c('i', {
    staticClass: "fa fa-ticket-alt style-scope app-menulist"
  }), _vm._v(" "), _c('span', {
    staticClass: "labelItem style-scope app-menulist"
  }, [_vm._v("Serviços")])])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-container style-scope app-menulist",
    attrs: {
      "data-tippy-content": "Pagamentos",
      "tabindex": "0"
    }
  }, [_c('a', {
    staticClass: "links style-scope app-menulist",
    attrs: {
      "href": "#/dashboard/admin/payments"
    }
  }, [_c('div', {
    staticClass: "item style-scope app-menulist"
  }, [_c('i', {
    staticClass: "fa fa-dollar-sign style-scope app-menulist"
  }), _vm._v(" "), _c('span', {
    staticClass: "labelItem style-scope app-menulist"
  }, [_vm._v("Pagamentos")])])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-container style-scope app-menulist",
    attrs: {
      "data-tippy-content": "Transações",
      "tabindex": "0"
    }
  }, [_c('a', {
    staticClass: "links style-scope app-menulist",
    attrs: {
      "href": "#/dashboard/admin/transactions"
    }
  }, [_c('div', {
    staticClass: "item style-scope app-menulist"
  }, [_c('i', {
    staticClass: "fa fa-exchange-alt style-scope app-menulist"
  }), _vm._v(" "), _c('span', {
    staticClass: "labelItem style-scope app-menulist"
  }, [_vm._v("Transações")])])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-container style-scope app-menulist",
    attrs: {
      "data-tippy-content": "Usuários",
      "tabindex": "0"
    }
  }, [_c('a', {
    staticClass: "links style-scope app-menulist",
    attrs: {
      "href": "#/dashboard/admin/users"
    }
  }, [_c('div', {
    staticClass: "item style-scope app-menulist"
  }, [_c('i', {
    staticClass: "fa fa-user-friends style-scope app-menulist"
  }), _vm._v(" "), _c('span', {
    staticClass: "labelItem style-scope app-menulist"
  }, [_vm._v("Usuários123")])])])]), _vm._v(" "), void 0], 2), _vm._v(" "), _vm._m(1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-content collapse shrink style-scope tpl-dashboard"
  }, [_c('div', {
    staticClass: "leftbar-header general-padding-left-app color-primary shadow-primary-black style-scope tpl-dashboard"
  }, [_c('a', {
    staticClass: "no-effect-link style-scope tpl-dashboard",
    attrs: {
      "href": "https://royalpag.com/#/dashboard"
    }
  }, [_c('img', {
    staticClass: "logo-principal style-scope tpl-dashboard",
    attrs: {
      "src": "https://royalpag.com/img/logo-transparent.png",
      "alt": "Royal Pag",
      "width": "132px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-logo-coroa style-scope tpl-dashboard"
  }, [_c('img', {
    staticClass: "logo-coroa style-scope tpl-dashboard",
    attrs: {
      "src": "https://royalpag.com/img/icon-crown.png"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-flow style-scope tpl-dashboard",
    attrs: {
      "data-tippy-content": "Logout",
      "tabindex": "0"
    }
  }, [_c('button', {
    staticClass: "btn line white signout style-scope tpl-dashboard"
  }, [_c('i', {
    staticClass: "fas fa-door-closed style-scope tpl-dashboard"
  }), _vm._v(" "), _c('span', {
    staticClass: "style-scope tpl-dashboard"
  }, [_vm._v("Logout123")])]), _vm._v(" "), _c('div', {
    staticClass: "footers-links style-scope tpl-dashboard"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9591a770","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/auth/menu.vue
// module id = nVBk
// module chunks = 36